import React, { Component } from 'react'
import { connect } from 'react-redux'
import propTypes from 'prop-types';
import { changePage, sendOrder, getDeliveryLocation } from '../../action/hcommerce'
import { getGuestInRoom, popupOpenClose, setLoadingMass, setOrderDetailPage } from '../../action/action'
import { months } from '../../config/constant'
import { hCommButtonColor } from '../../JS/setColors'
import { setWebViewAfterKeyBoard } from '../../JS/setWebView'

class MyOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savedOrders: [],
            placedOrder: [],
            orderTime: [],
            currentPage: "current"
        }
    }

    componentDidMount() {
        let savedOrders = localStorage.getItem("savedOrders");
        let placedOrder = localStorage.getItem("placedOrder");
        if (savedOrders) {
            savedOrders = JSON.parse(savedOrders);
            this.setState({ savedOrders: savedOrders });
        }
        this.setOrderTime();
        this.props.getGuestInRoom(this.props.guestDetail);
        // this.props.getDeliveryLocation(this.props.currentWidget.storeSku);
        if (placedOrder) {
            placedOrder = JSON.parse(placedOrder);
            if (placedOrder && placedOrder.length > 0) {
                this.setState({ placedOrder: placedOrder });
            }
        } else {
            console.log("there no order placed yet.");
        }
        hCommButtonColor(this.props.menuColor);
    }

    changeOrderPage = (page) => {
        this.setState({ currentPage: page })
    }

    goBack = () => {
        this.props.changePage("FoodTime");
    }

    setOrderTime = () => {
        let orderTime = [], nextHour;
        if (this.props.serverTime.hours === 23) {
            nextHour = 0;
        } else {
            nextHour = this.props.serverTime.hours + 1;
        }
        if (this.props.serverTime.minutes + 7 > 45) {
            orderTime = [
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:30` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:45` }
            ]
        } else if (this.props.serverTime.minutes + 7 > 30) {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:30` }
            ]
        } else if (this.props.serverTime.minutes + 7 > 15) {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:30` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` }
            ]
        } else {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:15` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:30` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` }
            ]
        }
        this.setState({ orderTime: orderTime });
    }

    placeOrder = () => {
        let room = localStorage.getItem("room")
        let selectedGuestDetail, orderItemList = [], tempObj, tempAddOn = [];
        let comment = document.getElementById("AdditionalNote").value
        let orderTime = document.getElementById("selectOrderTime").value
        let deliverLocation = room && room !== "null" ? room : null
        if (this.props.deliveryLocations.length > 0) {
            deliverLocation = document.getElementById("selecteddeliverLocation").value
        }
        console.log("deliverLocation", deliverLocation);
        if (this.props.CheckedInGuest.length > 0) {
            this.props.CheckedInGuest.map((iterator) => {
                if (iterator.guestName === this.props.guestDetail.guestName) {
                    selectedGuestDetail = iterator
                }
            })
        } else {
            console.log("No Guest name slected.");
        }
        if (this.state.savedOrders.length > 0) {
            this.state.savedOrders.map((iterator) => {
                iterator.addOns.map((addOnIterator) => {
                    tempAddOn.push({ "itemAddonId": addOnIterator.id, "itemPrice": addOnIterator.price })
                })
                tempObj = {
                    "storeItemId": iterator.item.id,
                    "quantity": iterator.quantity,
                    "pricePerItem": iterator.item.itemPrice,
                    "guestComment": comment,
                    "addOns": tempAddOn
                }
                orderItemList.push(tempObj);
            })
            console.log("orderItemList", orderItemList)
        } else {
            console.log("please select the food which you want to order.");
            this.props.popupOpenClose(true, "Please select the food which you want to order.");
        }

        //console.log("selectedGuestDetail", selectedGuestDetail);
        if (deliverLocation && selectedGuestDetail.id && orderTime && this.state.savedOrders.length > 0) {
            this.props.sendOrder(
                deliverLocation,
                selectedGuestDetail,
                orderTime, comment,
                this.state.savedOrders,
                this.props.currentWidget,
                orderItemList,
                this.callBackFromOrderAPI
            );
            this.props.setLoadingMass(true);
        } else {
            console.log("All details are not there.");
        }
    }

    callBackFromOrderAPI = (status) => {
        let addPlaceddate
        let serverDate = new Date(this.props.serverDate.date);
        let orderPlaceDate, hours, timeOfTheDay;
        let serverMin = this.props.serverDate.time.minutes
        if (this.props.serverDate.time.hours > 12) {
            hours = this.props.serverDate.time.hours - 12;
            timeOfTheDay = "PM"
        } else {
            hours = this.props.serverDate.time.hours;
            timeOfTheDay = "AM"
        }
        orderPlaceDate = `${hours < 10 ? `0${hours}` : hours}:${serverMin < 10 ? `0${serverMin}` : serverMin}${timeOfTheDay} ${serverDate.getDate()} ${months[serverDate.getMonth()]} ${serverDate.getFullYear()}`
        console.log("orderPlaceDate", orderPlaceDate);

        if (status) {
            this.props.setLoadingMass(false);
            this.props.popupOpenClose(true, "Order placed successfully.");
            let placedOrder = localStorage.getItem("placedOrder");
            if (placedOrder) {
                placedOrder = JSON.parse(placedOrder);
                this.state.savedOrders.map((iterator) => {
                    addPlaceddate = { ...iterator, orderPlacedDate: orderPlaceDate }
                    placedOrder.push(addPlaceddate);
                })
                console.log("placedOrder", placedOrder)
            } else {
                placedOrder = []
                this.state.savedOrders.map((iterator) => {
                    addPlaceddate = { ...iterator, orderPlacedDate: orderPlaceDate }
                    placedOrder.push(addPlaceddate);
                })
                console.log("placedOrder", placedOrder)
            }
            localStorage.setItem("placedOrder", JSON.stringify(placedOrder));
            this.setState({ placedOrder: placedOrder });
            localStorage.setItem("savedOrders", "");
            this.setState({ savedOrders: [] });
        } else {
            this.props.setLoadingMass(false);
            this.props.popupOpenClose(true, "There are some unkown issue please try again.");
        }
    }
    quantityIncress = (itemDetail) => {
        let copySavedOrders = [...this.state.savedOrders]
        copySavedOrders.map((iterator) => {
            if (iterator.item.id === itemDetail.item.id) {
                iterator.quantity = iterator.quantity + 1;
                iterator.totalPrice = iterator.totalPrice + iterator.item.itemPrice
            }
        })
        this.setState({ savedOrders: copySavedOrders });
        localStorage.setItem("savedOrders", JSON.stringify(copySavedOrders));
    }

    removeSaveditem = (itemDetail) => {
        let copySavedOrders = [...this.state.savedOrders]
        copySavedOrders.map((iterator, index) => {
            if (iterator.item.id === itemDetail.item.id) {
                copySavedOrders.splice(index, 1);

            }
        })
        this.setState({ savedOrders: copySavedOrders });
        localStorage.setItem("savedOrders", JSON.stringify(copySavedOrders));
    }

    quantityDecrease = (itemDetail) => {
        let copySavedOrders = [...this.state.savedOrders]
        copySavedOrders.map((iterator) => {
            if (iterator.item.id === itemDetail.item.id) {
                if (iterator.quantity > 1) {
                    iterator.quantity = iterator.quantity - 1;
                    iterator.totalPrice = iterator.totalPrice - iterator.item.itemPrice
                } else {
                    console.log("quantity", iterator.quantity);
                }
            }
        })
        this.setState({ savedOrders: copySavedOrders });
        localStorage.setItem("savedOrders", JSON.stringify(copySavedOrders));
    }

    showOrderDetails = (itemDetail) => {
        console.log("itemDetail", itemDetail);
        this.props.setOrderDetailPage(true, itemDetail);
    }
    render() {

        let allOrderTotalPrice = 0;
        let allPlacedOrderTotal = 0
        return (
            <div id="rs-order-list" class="movie-widgets" style={{ color: "inherit" }}>
                <div class="search-back" data-target="rs-main" onClick={this.goBack}>
                    <i class="fa fa-chevron-left" style={{ color: "inherit" }}></i> Back</div>
                <div id="my-orders" class="tab-list">
                    <ul style={{ color: "inherit" }}>
                        <li
                            id="CurrentHCommOrders"
                            onClick={() => { this.changeOrderPage("current") }}
                            style={
                                this.state.currentPage === "current" &&
                                    this.props.menuColor.assetBackgroundSelectorColor ?
                                    { backgroundColor: `${this.props.menuColor.assetBackgroundSelectorColor}` } : {}
                            }
                            class={this.state.currentPage === "current" ? "tab-button selected" : "tab-button"}
                            data-target="current-orders">
                            Current Orders
                        </li>
                        <li
                            id="PlacedHCommOrders"
                            style={
                                this.state.currentPage === "placed" &&
                                    this.props.menuColor.assetBackgroundSelectorColor ?
                                    { backgroundColor: `${this.props.menuColor.assetBackgroundSelectorColor}` } : {}
                            }
                            onClick={() => { this.changeOrderPage("placed") }}
                            class={this.state.currentPage === "placed" ? "tab-button selected" : "tab-button"}
                            data-target="pending-orders">
                            Placed orders
                        </li>
                    </ul>
                </div>
                <div class="tab-list-item current-orders"
                    style={
                        this.state.currentPage === "current" ?
                            { background: "rgba(255,255,255,0.9)", color: "inherit" } :
                            { background: "rgba(255,255,255,0.9)", display: "none" }
                    }>
                    <h4 style={{ margin: 0, padding: "1rem", color: "inherit" }}>My Current Orders</h4>
                    <div class="rs-orders-listing" style={{ background: "rgba(255,255,255,0.9)", color: "inherit" }}>
                        <table class="w-100" cellpadding="10" style={{ color: "inherit" }}>
                            <thead style={{ color: "inherit" }}>
                                <tr style={{ color: "inherit" }}>
                                    <th style={{ padding: '10px', color: "inherit" }} class="w-45">Description</th>
                                    <th style={{ color: "inherit" }} class="w-25">Qty</th>
                                    <th style={{ color: "inherit" }} class="w-25">Amount</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody style={{ color: "inherit" }}>
                                {this.state.savedOrders && this.state.savedOrders.length > 0 ?
                                    this.state.savedOrders.map((iterator) => {
                                        allOrderTotalPrice += iterator.totalPrice;
                                        return (
                                            < tr style={{ color: "inherit" }}>
                                                <td style={{ padding: '10px', color: "inherit" }}>
                                                    <a onClick={() => { this.showOrderDetails(iterator) }}>
                                                        {iterator.item.itemName}
                                                        <i class="fa fa-info-circle" style={{ marginLeft: "5px" }}></i>
                                                    </a>
                                                </td>
                                                <td style={{ color: "inherit" }}>
                                                    <input type="tel" style={{ textAlign: "center" }} name="" value={iterator.quantity} />
                                                    <a onClick={() => { this.quantityIncress(iterator) }}>
                                                        <i class="fa fa-plus-circle"></i>
                                                    </a>
                                                    <a onClick={() => { this.quantityDecrease(iterator) }} style={{ marginLeft: "5px" }}>
                                                        <i class="fa fa-minus-circle"></i>
                                                    </a>
                                                </td>
                                                <td style={{ color: "inherit" }}>
                                                    {`${this.props.currencyCode} ${
                                                        Math.ceil(iterator.totalPrice) > iterator.totalPrice && Math.floor(iterator.totalPrice) < iterator.totalPrice
                                                            ? iterator.totalPrice.toFixed(2) : iterator.totalPrice
                                                        }`}
                                                </td>
                                                <td style={{ color: "inherit" }}>
                                                    <a onClick={() => { this.removeSaveditem(iterator) }} style={{ color: "inherit" }}><i class="fa fa-close" style={{ color: "inherit" }}></i></a>
                                                </td>
                                            </tr>
                                        )
                                    }) : "No order has been saved. You can browse menu."
                                }
                            </tbody>
                            <tfoot style={{ color: "inherit" }}>
                                <tr style={{ color: "inherit" }}>
                                    <td colspan="2" style={{ padding: '10px', color: "inherit" }}><strong style={{ color: "inherit" }}>Total</strong></td>
                                    <td colspan="2" style={{ color: "inherit" }}>
                                        <strong style={{ color: "inherit" }}>
                                            {`${this.props.currencyCode} ${
                                                Math.ceil(allOrderTotalPrice) > allOrderTotalPrice && Math.floor(allOrderTotalPrice) < allOrderTotalPrice
                                                    ? allOrderTotalPrice.toFixed(2) : allOrderTotalPrice
                                                }`}
                                        </strong>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="rs-order-details flex" style={{ background: "rgba(255,255,255,0.9)", color: "inherit" }}>
                        <div class="form-item w-45" style={{ marginRight: "1.5rem", color: "inherit" }}>
                            <label style={{ color: "inherit" }}>Delivery time</label>
                            <select id="selectOrderTime" name="del-time">
                                {
                                    this.state.orderTime.length > 0 ?
                                        this.state.orderTime.map((iterator) => {
                                            return (
                                                <option value={iterator.time}>{iterator.time}</option>
                                            )
                                        })
                                        : null
                                }
                            </select>
                        </div>
                        {
                            this.props.deliveryLocations.length > 0 ?
                                <div class="form-item w-45" style={{ color: "inherit" }}>
                                    <label style={{ color: "inherit" }}>Deliver to</label>
                                    <select id="selecteddeliverLocation" name="del-time">
                                        {
                                            this.props.deliveryLocations.map((iterator) => {
                                                return (
                                                    <option value={iterator.locationNumber}>{iterator.locationNumber}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div> : null
                        }
                    </div>
                    <div class="rs-add-info form-item" style={{ background: "rgba(255,255,255,0.9)", padding: "1rem", color: "inherit" }}>
                        <div class="form-item" style={{ color: "inherit" }}>
                            <label style={{ color: "inherit" }}>Additional Requests</label>
                            <textarea
                                id="AdditionalNote"
                                name="additional request" rows="2"
                                style={{ background: " rgb(248, 248, 248)" }}
                                onBlur={(event) => { setWebViewAfterKeyBoard(event) }}
                            >
                            </textarea>
                        </div>
                        <div class="form-controls center">
                            <a class="button" onClick={this.placeOrder}>Place orders</a>
                            <a class="button secondary" style={{ marginLeft: "5px" }}
                                onClick={this.goBack}>
                                Browse menu
                            </a>
                        </div>
                    </div>
                </div>
                <div class="tab-list-item pending-orders"
                    style={this.state.currentPage === "placed" ?
                        { background: "rgba(255,255,255,0.9)", color: "inherit" } :
                        { background: "rgba(255,255,255,0.9)", display: "none" }
                    }>
                    <h4 style={{ margin: 0, padding: "1rem", color: "inherit" }}>My Placed Orders</h4>
                    <div class="rs-orders-listing" style={{ color: "inherit" }}>
                        <table class="w-100" cellpadding="10" style={{ color: "inherit" }}>
                            <thead style={{ color: "inherit" }}>
                                <tr style={{ color: "inherit" }}>
                                    <th class="w-45" style={{ color: "inherit" }}>Description</th>
                                    <th style={{ color: "inherit" }}>Qty</th>
                                    <th class="w-25" style={{ color: "inherit" }}>Amount</th>
                                    <th class="w-25" style={{ color: "inherit" }}>Time ordered</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: "inherit" }}>
                                {
                                    this.state.placedOrder.map((iterator) => {
                                        allPlacedOrderTotal = allPlacedOrderTotal + iterator.totalPrice
                                        return (
                                            <tr style={{ color: "inherit" }}>
                                                <td style={{ color: "inherit" }}>
                                                    <a onClick={() => { this.showOrderDetails(iterator) }} style={{ color: "inherit" }}>
                                                        {iterator.item.itemName} <i class="fa fa-info-circle" style={{ color: "inherit" }}></i>
                                                    </a>
                                                </td>
                                                <td style={{ color: "inherit" }}>{iterator.quantity}</td>
                                                <td style={{ color: "inherit" }}>
                                                    {`${this.props.currencyCode} ${
                                                        Math.ceil(iterator.totalPrice) > iterator.totalPrice && Math.floor(iterator.totalPrice) < iterator.totalPrice
                                                            ? iterator.totalPrice.toFixed(2) : iterator.totalPrice
                                                        }`}
                                                    {/* ${this.props.currencyCode}{iterator.totalPrice} */}
                                                </td>
                                                <td style={{ color: "inherit" }}>{iterator.orderPlacedDate}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                            <tfoot style={{ color: "inherit" }}>
                                <tr style={{ color: "inherit" }}>
                                    <td colspan="2" style={{ color: "inherit" }}><strong style={{ color: "inherit" }}>Total</strong></td>
                                    <td colspan="2" style={{ color: "inherit" }}>
                                        <strong style={{ color: "inherit" }}>
                                            {`${this.props.currencyCode} ${
                                                Math.ceil(allPlacedOrderTotal) > allPlacedOrderTotal && Math.floor(allPlacedOrderTotal) < allPlacedOrderTotal
                                                    ? allPlacedOrderTotal.toFixed(2) : allPlacedOrderTotal
                                                }`}
                                        </strong></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentPage: state.store.Hcommerce.currentPage,
        serverTime: state.store.home.serverTimeDate.time,
        CheckedInGuest: state.store.CheckedInGuest,
        currentWidget: state.store.sideNavBar.currentWidget,
        serverDate: state.store.home.serverTimeDate,
        deliveryLocations: state.store.Hcommerce.deliveryLocations,
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : ""
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        getGuestInRoom,
        sendOrder,
        popupOpenClose,
        setLoadingMass,
        getDeliveryLocation,
        setOrderDetailPage
    }
)(MyOrder);

/*
<div id="rs-order-list" class="movie-widgets">
    <div class="search-back" data-target="rs-main" onClick={this.goBack}>
        <i class="fa fa-chevron-left"></i> Back</div>
    <h4>My orders</h4>
    <div class="rs-orders-listing" style={{ background: "rgba(255,255,255,0.9)" }}>
        <table class="w-100" cellpadding="10">
            <thead>
                <tr>
                    <th style={{ padding: '10px' }} class="w-45">Description</th>
                    <th class="w-25">Qty</th>
                    <th class="w-25">Amount</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {this.state.savedOrders.length > 0 ?
                    this.state.savedOrders.map((iterator) => {
                        allOrderTotalPrice += iterator.totalPrice;
                        return (
                            < tr >
                                <td style={{ padding: '10px' }}>{iterator.item.itemName}</td>
                                <td>
                                    <input type="tel" style={{ textAlign: "center" }} name="" value={iterator.quantity} />
                                    <a onClick={() => { this.quantityIncress(iterator) }}>
                                        <i class="fa fa-plus-circle"></i>
                                    </a>
                                    <a onClick={() => { this.quantityDecrease(iterator) }} style={{ marginLeft: "5px" }}>
                                        <i class="fa fa-minus-circle"></i>
                                    </a>
                                </td>
                                <td>
                                    {`$${iterator.totalPrice}`}
                                </td>
                                <td>
                                    <a onClick={() => { this.removeSaveditem(iterator) }}><i class="fa fa-close"></i></a>
                                </td>
                            </tr>
                        )
                    }) : "No order has been saved. You can browse menu."
                }
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2" style={{ padding: '10px' }}><strong>Total</strong></td>
                    <td colspan="2"><strong>{`$${allOrderTotalPrice}`}</strong></td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div class="rs-order-details flex" style={{ background: "rgba(255,255,255,0.9)" }}>
        <div class="form-item w-45" style={{ marginRight: "1.5rem" }}>
            <label>Delivery time</label>
            <select id="selectOrderTime" name="del-time">
                {
                    this.state.orderTime.length > 0 ?
                        this.state.orderTime.map((iterator) => {
                            return (
                                <option value={iterator.time}>{iterator.time}</option>
                            )
                        })
                        : null
                }
            </select>
        </div>
        <div class="form-item w-45">
            <label>Deliver to</label>
            <select id="selecteddeliverLocation" name="del-time">
                {this.props.CheckedInGuest.length > 0 ?
                    this.props.CheckedInGuest.map((iterator) => {
                        return (
                            <option value={iterator.guestName}>{iterator.guestName}</option>
                        )
                    }) : null
                }
            </select>
        </div>
    </div>
    <div class="rs-add-info form-item" style={{ background: "rgba(255,255,255,0.9)", padding: "1rem" }}>
        <div class="form-item">
            <label>Additional Requests</label>
            <textarea id="AdditionalNote" name="additional request" rows="2" style={{ background: " rgb(248, 248, 248)" }}></textarea>
        </div>
        <div class="form-controls center">
            <a class="button" onClick={this.placeOrder}>Place orders</a>
            <a class="button secondary" style={{ marginLeft: "5px" }}
                onClick={this.goBack}>
                Browse menu
        </a>
        </div>
    </div>
</div >

*/